import { LDFlagSet } from 'launchdarkly-js-sdk-common'
import type { DashboardCardDef } from '../types'

export const filterCardsByFeatureSet = (cards: DashboardCardDef[], flags: LDFlagSet): DashboardCardDef[] => {
    return cards.filter((card) => {
        if (!card.featureFlags) return true
        const { include = [], exclude = [] } = card.featureFlags
        return evaluateFeatureFlags({include, exclude, flags})
    })
}

interface EvaluateFeatureFlagsProps {
    flags: LDFlagSet
    include?: string[]
    exclude?: string[]
}
export function evaluateFeatureFlags({ flags, include, exclude }: EvaluateFeatureFlagsProps): boolean {
    const includeFlag = include?.length ? include.some((flag) => flags[flag]) : true
    const excludeFlag = exclude?.length ? exclude.some((flag) => flags[flag]) : false
    return includeFlag && !excludeFlag
}

